'use client';

import {signOut} from 'next-auth/react';

export const useSignOut = () => {
  return async () => {
    // Clear NextAuth session first
    await signOut({redirect: false});

    // Redirect to federated logout API route (clears Auth0 session)
    window.location.href = `/api/auth/federated-logout`;
  };
};
